import React, { useEffect, useState } from 'react';
import Columns from '@/components/Columns';
import Column from '@/components/Column';
import Button from '@/components/Button';
import Text from '@/components/Text';
import './styles.css';

type UnauthorizedAlertProps = {
  setShowUnauthorizedAlert(value: boolean): void;
};

const UnauthorizedAlert: React.FC<UnauthorizedAlertProps> = ({
  setShowUnauthorizedAlert,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);
  return (
    <div
      className={`alert-change-container flex items-center justify-center ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <Columns
        as='aside'
        className='mx-6 flex flex-col items-center justify-center rounded-lg bg-white p-5 lg:m-0'
        useNegativeMargin={false}
      >
        <Text as='h1' kind='blue' size='2xl' className='font-bold'>
          Pagamento não autorizado no cartão
        </Text>
        <Column className='itens-center flex flex-col justify-between'>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            Ocorreu um problema com seu cartão de crédito.
          </Text>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            Para continuar, será necessário cadastrar novo cartão de crédito.
          </Text>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            Confira se os dados foram digitados corretamente e tente novamente.
          </Text>
          <Column className='px-5 pt-2'>
            <Button
              kind='primary'
              large
              onClick={() => setShowUnauthorizedAlert(false)}
            >
              Entendi
            </Button>
          </Column>
        </Column>
      </Columns>
    </div>
  );
};

export default UnauthorizedAlert;
